// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2uz7{margin:.8rem 0;padding:.8rem .6rem;background:#fff;box-shadow:0 .4rem .8rem 0 rgba(0,0,0,.08);flex:1;cursor:pointer}._1Ruf{display:flex;align-items:center}._2GQU{max-width:5rem}._1ZyV{flex:1}", ""]);
// Exports
exports.locals = {
	"labelWrapp": "_2uz7",
	"product": "_1Ruf",
	"imgWrapp": "_2GQU",
	"name": "_1ZyV"
};
module.exports = exports;
